// extracted by mini-css-extract-plugin
export default {"patchQuestionIcon":"MailMergeStatusRenderer_patchQuestionIcon__cBvUg","approvalStatusWrapper":"MailMergeStatusRenderer_approvalStatusWrapper__bjI9O"};